module.exports = __webpack_public_path__ + "static/media/certificate.5dcd293a.png";